// Helper per Visualizza / Scarica / Condividi (README §7).
// Le URL sono signed URL applicative a TTL breve restituite dall'API.

/** Apre un file in una nuova scheda (viewer del browser). */
export function viewUrl(url: string): void {
  window.open(url, '_blank', 'noopener,noreferrer');
}

/** Forza il download del file (il blob endpoint imposta già content-disposition). */
export function downloadUrl(url: string, filename?: string): void {
  const a = document.createElement('a');
  a.href = url;
  if (filename) a.download = filename;
  a.rel = 'noopener';
  document.body.appendChild(a);
  a.click();
  a.remove();
}

/**
 * Condivisione: prova Web Share API con file (se supportata), poi con testo;
 * altrimenti ritorna false per consentire un fallback (es. copia negli appunti).
 */
export async function shareFile(opts: {
  url?: string;
  filename?: string;
  mime?: string;
  title: string;
  text?: string;
}): Promise<boolean> {
  // Tentativo con file allegato.
  if (opts.url && typeof navigator.canShare === 'function') {
    try {
      const res = await fetch(opts.url);
      const blob = await res.blob();
      const file = new File([blob], opts.filename ?? 'documento', { type: opts.mime ?? blob.type });
      if (navigator.canShare({ files: [file] })) {
        await navigator.share({ files: [file], title: opts.title, text: opts.text });
        return true;
      }
    } catch {
      /* prosegui col fallback testo */
    }
  }
  // Fallback: condivisione di solo testo.
  if (typeof navigator.share === 'function') {
    try {
      await navigator.share({ title: opts.title, text: opts.text });
      return true;
    } catch {
      return false;
    }
  }
  return false;
}
